"use client";
import Logo from "@/components/header/nav-bar/logo";
import Search from "@/components/header/nav-bar/search";
import NavBarRight from "@/components/header/nav-bar/nav-bar-right";
import React from "react";
import {Button} from "antd";
import {getCartCount} from "@/service/action/cart-list";
import { usePathname } from "next/navigation";

export default  function NavBar() {


    return <header className="bg-white h-navbar">
        <div className="container h-full bg-white b-flex gap-x-6">
            <Logo />
            <Search />
            <NavBarRight count={0}/>
        </div>
    </header>;
}


